<script>
import Loader from './Loader.vue';
/**
 * Login/Registration modal.
 * Made using https://vuejs.org/v2/examples/modal.html
 */
export default {
    components: { Loader },

    data() {
        return {
            type: 'Login',

            isLoading: false,

            // Terms and Conditions checkbox
            tacChecked: false,

            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            loginErrors: {},
            registerErrors: {},
        };
    },

    methods: {

        /**
         * Login the account
         * Set access_token and profile to state
         * TODO: Proper error messages.
         */
        async login() {
            this.isLoading = true;
            this.loginErrors = {};

            try {
                const response = await window.axios.post(
                    '/api/login',
                    { email: this.email, password: this.password },
                );

                // Store login data to state
                this.$store.commit('login', response.data);

                if (this.$store.getters.isAuthenticated) {
                    this.$store.dispatch('loadProfileData');
                }
                
        
                // Close the popup modal
                this.$emit('close');
            } catch (error) {
                this.loginErrors = error.response.data;
            } finally {
                this.isLoading = false;
            }
        },


        /**
         * Register new account
         * After registration automatically login
         */
        async register() {
            this.isLoading = true;
            this.registerErrors = {};

            try {
                const response = await window.axios.post(
                    '/api/register',
                    {
                        name: this.name,
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                        terms_and_conditions: this.tacChecked,
                    },
                );
                // Store login data to state
                this.$store.commit('login', response.data);

                // Close the popup modal
                this.$emit('close');

                // Display message to confirm the mail and check spam
                Vue.toasted.show(
                    'Thank you for registering! Please confirm your email before you start posting, be sure to check the spam folder if no mail has reached you.', 
                    { duration: 6000, icon: 'check' },
                );
            } catch (error) {
                this.registerErrors = error.response.data;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<template lang='pug' src='./template/LoginModal.pug'></template>
<style lang='stylus' src='./styles/LoginModal.styl' scoped></style>
